import HeroComp from "../components/home_component/Hero";

const HeroP = () => {
    return ( 
        <>
        <HeroComp/>
        </>
     );
}
 
export default HeroP;